import React, { createContext, PropsWithChildren, useContext } from 'react';

export const BootstrapVersionContext = createContext<3 | 4 | undefined>(undefined);
export const BootstrapVersionProvider = (
    { version, children }: PropsWithChildren<{ version: 3 | 4 }>
) => (
    <BootstrapVersionContext.Provider value={version}>
        {children}
    </BootstrapVersionContext.Provider>
);

const useBootstrapVersion = () => {
    const result = useContext(BootstrapVersionContext);

    if (!result) {
        throw new Error('useBootstrapVersion must be used within a <BootstrapVersionProvider/>');
    }

    return result;
};

export default useBootstrapVersion;
